module.exports = __webpack_public_path__ + "static/elephanty-welcome-b9ff7dd716de2d0fc458bf9a4b8bcfb6.png";